import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerContrattiAClienteModalComponent} from './worker-contratti-a-cliente-modal';

export const WorkerContrattiAClienteModalModule: string = ng
    .module('worker-contratti_a_cliente-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerContrattiAClienteModalComponent', WorkerContrattiAClienteModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-contratti-a-cliente-modal/worker-contratti-a-cliente-modal.module.ts